import { Store } from 'vuex';
import { auth } from '../firebase';

export async function fetchWithAuth(
  url: string,
  options: RequestInit = {},
  store: Store<any>
): Promise<Response> {
  try {
    // Refresh token first
    await store.dispatch('refreshIdToken');
    let token = store.getters.getIdToken;

    const makeRequest = async (tokenToUse: string) => {
      const headers: HeadersInit = {
        'Authorization': `Bearer ${tokenToUse}`,
        'Content-Type': 'application/json',
        ...(options.headers || {})
      };

      return await fetch(url, {
        ...options,
        headers
      });
    };

    let response = await makeRequest(token);

    // If 401, try refreshing token once more, then logout if still unauthorized
    if (response.status === 401) {
      await store.dispatch('refreshIdToken');
      token = store.getters.getIdToken;
      response = await makeRequest(token);

      if (response.status === 401) {
        // Unauthorized after retry, logout user
        store.commit('clearAuth');
        await auth.signOut();
        throw new Error('Unauthorized. User logged out.');
      }
    }

    return response;
  } catch (error) {
    console.error('fetchWithAuth error:', error);
    throw error;
  }
}
